import constructLocalEntity from 'src/utils/vuexModuleConstructor/constructLocalEntity';
import { isInteger, hideWhenDisplaying, hideWhenCreatingAndEditing } from 'src/types/columnFlags';
const controlledActions = {
    create: [436],
    fetch: [437],
    update: [438],
    delete: [439],
    downloadList: [437],
    uploadList: [-1]
};
const columns = (state, getters, rootState, rootGetters) => {
    return [
        { name: 'row_menu', type: 'row_menu', menuItemShortcuts: ['delete'], hideWhenCreatingAndEditing },
        { name: 'id', style: 'width:80px', isInteger, hideWhenDisplaying, hideWhenCreatingAndEditing },
        { name: 'location_id', disguised: true, label: 'Location ID', align: 'left', references: 'orgs.orgs', hideWhenDisplaying },
        { name: 'location_name', disguised: true, label: 'Location', hideWhenCreatingAndEditing },
        { name: 'benchmark_product_native_id', label: 'Benchmark product native ID', inlineEdit: true },
        { name: 'current_price', label: 'Current price', inlineEdit: true, isCurrency: true },
        { name: 'price_last_updated_at', label: 'Last update', isDateTime: true, hideWhenCreatingAndEditing }
    ];
};
const localEntity = constructLocalEntity({
    // @ts-ignore
    columns,
    remoteEntityName: 'ci.broker_price_benchmark_products',
    apiVersion: 1,
    controlledActions,
    pageTitle: 'Broker-price benchmark products'
});
export default localEntity;
